/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_ProjectInputs */

const en_save_project = /** @type {(inputs: Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Project`)
};

const fr_save_project = /** @type {(inputs: Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer le projet`)
};

const de_save_project = /** @type {(inputs: Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt speichern`)
};

const it_save_project = /** @type {(inputs: Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva progetto`)
};

const ru_save_project = /** @type {(inputs: Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить проект`)
};

const es_save_project = /** @type {(inputs: Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar proyecto`)
};

const zh_cn2_save_project = /** @type {(inputs: Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存项目`)
};

const ja_save_project = /** @type {(inputs: Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトを保存`)
};

const hi_save_project = /** @type {(inputs: Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट बचाओ`)
};

const pt_pt2_save_project = /** @type {(inputs: Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar projeto`)
};

/**
* | output |
* | --- |
* | "Save Project" |
*
* @param {Save_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const save_project = /** @type {((inputs?: Save_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_save_project(inputs)
	if (locale === "de") return de_save_project(inputs)
	if (locale === "it") return it_save_project(inputs)
	if (locale === "ru") return ru_save_project(inputs)
	if (locale === "es") return es_save_project(inputs)
	if (locale === "zh-CN") return zh_cn2_save_project(inputs)
	if (locale === "ja") return ja_save_project(inputs)
	if (locale === "hi") return hi_save_project(inputs)
	if (locale === "pt-PT") return pt_pt2_save_project(inputs)
	return en_save_project(inputs)
});